module.exports = __webpack_public_path__ + "static/Forma Ai-b4b37314704577a51e20d8804c6b09a8.jpg";